import React from "react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { challenges } from "../../data/content";
export function Challenges() {
  return <section className="bg-cream px-4 py-16 sm:py-24" data-id="element-126" data-mp="2cyxg3icr3xkw">
      <SectionHeading kicker="Do you recognize these challenges?" title="The Everyday Planning Tasks That Can Take More Time Than Expected" data-id="element-127" data-mp="2cyff68f58v6n" />

      <ol className="mx-auto mt-10 grid max-w-5xl gap-x-12 md:grid-cols-2" data-id="element-128" data-mp="230rl7kpd3rpj">
        {challenges.map((c, i) => <li key={c.title} className="flex gap-4 border-b border-navy/10 py-6" data-id="element-129" data-mp="27zun4wa1phta" data-mpi={i}>
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-sun font-display text-2xl font-bold text-navy" data-id="element-130" data-mp="1u033og0rf97w">
              {i + 1}
            </span>
            <div data-id="element-131" data-mp="3oduli2t8szef">
              <h3 className="font-display text-xl font-bold leading-snug text-navy sm:text-2xl" data-id="element-132" data-mp="3odb3yn7i8d0x">{c.title}</h3>
              <p className="mt-1.5 text-base leading-relaxed text-ink-soft sm:text-lg" data-id="element-133" data-mp="3td794prxuai2">{c.text}</p>
            </div>
          </li>)}
      </ol>

      <p className="mx-auto mt-10 max-w-2xl text-center text-lg font-semibold leading-relaxed text-navy" data-id="element-134" data-mp="xaaykit302x5">
        If these situations sound familiar, the Pediatric OT Planning System™ provides a practical starting point for organizing the planning side of your work.
      </p>
      <CtaButton label="Yes! I want a more organized workflow" className="mt-8" data-id="element-135" data-mp="123nlmoi441ns" />
    </section>;
}